module.exports = __webpack_public_path__ + "img/copy_trash_circle_white.a8980963.png";